@if (items?.length >= config?.displaySearchBarCount) {
	<div class="search-area" nhaTest="simple-list-search-area">
		<nha-search-box
			[lockOpen]="true"
			[placeholder]="config.placeholder"
			[boxShadow]="false"
			[gray]="config.searchBoxGray"
			(changed)="onSearchTermChange($event)"
		></nha-search-box>
	</div>
}

<ng-content select="[pre-list]"></ng-content>

<div class="list-container" [ngClass]="{ 'virtual-scroll': config.enableVirtualScroll, 'hover': config.hover, 'dense': dense }" nhaTest="simple-list-items">
	<ng-container *ngIf="items | filter: filterMethod as filteredItems">
		<ng-container *ngIf="filteredItems.length > 0; else noResultsTemplate">
			@if (config.enableVirtualScroll) {
				<cdk-virtual-scroll-viewport
					#cdkVirtualScroll
					[itemSize]="config.virtualItemSize ?? 40"
					class="simple-list-scroller"
					#scrollViewport
					[style]="config.customHeight ? 'height:' + config.customHeight : ''"
				>
					<ng-container *cdkVirtualFor="let item of filteredItems; trackBy: config.trackBy; index as i">
						<ng-template [ngTemplateOutlet]="dataAreaTemplate" [ngTemplateOutletContext]="{ item: item, index: i }"></ng-template>
					</ng-container>
				</cdk-virtual-scroll-viewport>
			} @else {
				@for (item of filteredItems; track config.trackBy($index, item)) {
					<ng-template [ngTemplateOutlet]="dataAreaTemplate" [ngTemplateOutletContext]="{ item: item, index: $index }"></ng-template>
				}
			}
		</ng-container>
	</ng-container>
</div>

<ng-template #dataAreaTemplate let-item="item" let-index="index">
	<div
		[ngStyle]="{ 'padding-left': config.itemPadLeft }"
		[ngClass]="{ 'item-selected': config.isSelected$ | templateFunc: [item] | async }"
		[nhaTest]="'simple-list-item-' + (index + 1)"
		class="list-item"
	>
		@if (config.link) {
			@if (config.linkIsExternal && config.linkIsExternal()) {
				<a [href]="config.link | templateFunc: [item]" (click)="onItemClick(item)" class="item-link" [target]="config.linkTarget">
					<ng-template [ngTemplateOutlet]="config.customTemplate || defaultListItemTemplate" [ngTemplateOutletContext]="{ item: item }"></ng-template>
				</a>
			} @else {
				<a
					[routerLink]="$any(config.link | templateFunc: [item])"
					[queryParams]="config.linkQueryParams ? $any(config.linkQueryParams | templateFunc: [item]) : null"
					(click)="onItemClick(item)"
					class="item-link"
					[target]="config.linkTarget"
				>
					<ng-template [ngTemplateOutlet]="config.customTemplate || defaultListItemTemplate" [ngTemplateOutletContext]="{ item: item }"></ng-template>
				</a>
			}
		} @else if (config.action !== undefined) {
			<button (click)="config.action(item)" class="item-action">
				<ng-template [ngTemplateOutlet]="config.customTemplate || defaultListItemTemplate" [ngTemplateOutletContext]="{ item: item }"></ng-template>
			</button>
		} @else {
			<div class="item">
				<ng-template [ngTemplateOutlet]="config.customTemplate || defaultListItemTemplate" [ngTemplateOutletContext]="{ item: item }"></ng-template>
			</div>
		}
		@if (config.customActionsTemplate) {
			<div class="action-menu">
				<ng-template [ngTemplateOutlet]="config.customActionsTemplate" [ngTemplateOutletContext]="{ item: item }"></ng-template>
			</div>
		}
	</div>
</ng-template>

<ng-content select="[post-list]"></ng-content>

<ng-template #defaultListItemTemplate let-item="item">
	<div [innerHTML]="config.html | templateFunc: [item]"></div>
</ng-template>

<ng-template #noResultsTemplate>
	@if (config.showNoResults) {
		<ng-template [ngTemplateOutlet]="config.customNoResultsTemplate || defaultNoResultsTemplate"></ng-template>
	}
</ng-template>

<ng-template #defaultNoResultsTemplate>
	<div class="no-results">No Results</div>
</ng-template>
